export const projects = [
  {
    title: "Audit Viewer",
    subtitle: "ABP Framework, Angular and PostgreSQL",
    description:
      "An interface that could show the ABP's ABPAuditLogs and ABPAuditLogActions tables with sorting and filtering options.",
    image: "./AuditViewer.gif",
    link: "https://github.com/muzoaydo/AuditViewer",
  },
  {
    title: "PySleeper",
    subtitle: "Python",
    description:
      "A desktop project that could put the computer in to sleep or shutdown mode in the given time.",
    image: "./PySleeper.gif",
    link: "https://github.com/muzoaydo/PySleeper",
  },
  {
    title: "PaymentApp",
    subtitle: "Angular",
    description:
      "A payment registiration page with validation messages and database management feature.",
    image: "./PaymentApp.jpg",
    link: "https://github.com/muzoaydo/PaymentApp",
  },
  {
    title: "Book Store",
    subtitle: "ABP Framework and Angular",
    description:
      "A book store app that shows the existing books and the authors availiable.",
    image: "BookStore.jpg",
    link: "https://github.com/muzoaydo/Acme.BookStore",
  },
];
export const skills = [
  "Angular", "React", "ABP", ".Net Core", "Python", "C", "Git", "PostgreSQL", "Linux", "C#", "HTML, CSS", "Matlab", "Simulink"
];


// WEBPACK FOOTER //
// ./src/data.js